import { config } from 'config';
import { toVfId } from 'commons/util/parse.js';
import { restAPIV2 } from './rest_api_v2';
import { restAPIV4 } from './rest_api_v4';

const routes = {
    user_by_uuid: (uuid) => `/users/${toVfId(uuid)}`,
    user_by_uuid_siteless: (uuid) => `/users/${toVfId(uuid)}/siteless`,
    current: () => '/users/current',
    ban_user: () => '/bans',
    subscribers: (siteUuid, userUuid) =>
        `/subscriptions/${siteUuid}/users/${userUuid}/subscribers`,
    subscriptions: (siteUuid, userUuid) =>
        `/subscriptions/${siteUuid}/users/${userUuid}/subscriptions`,
    refreshUserTokenRoute: () => '/users/refreshusertoken',
};

const getDefaultRestAPIV2 = (site_id) =>
    restAPIV2.register(config.api_v2_url, site_id);
const getDefaultRestAPIV4 = (site_id) =>
    restAPIV4.register(config.usernotification_api_url, site_id);


export const fetchUserByUuid = (uuid, site_uuid) => getDefaultRestAPIV2(toVfId(site_uuid)).get(routes.user_by_uuid(uuid));

export const fetchUserByUuidWithoutSite = (uuid) => getDefaultRestAPIV2(0).get(routes.user_by_uuid_siteless(uuid));

// CM-176: Temp PHP call to get user info for followers/following
export const fetchMultipleUsers = (users, site, siteUuid) => {
    const requests = users.reduce(
        (acc, userUuid) => ({
            ...acc,
            [userUuid]: {
                route: routes.user_by_uuid(userUuid),
                verb: 'get',
            },
        }),
        {},
    );

    return getDefaultRestAPIV2('').get('/', {
        section: toVfId(siteUuid),
        json: JSON.stringify({
            requests,
            site,
        }),
    });
};

export const fetchCurrentUser = (site_uuid) => getDefaultRestAPIV2(toVfId(site_uuid)).get(routes.current());

export const banUser = (data, site_uuid) => getDefaultRestAPIV2(toVfId(site_uuid)).post(routes.ban_user(), data);

export const fetchFollowing = (uuid, site_uuid) =>
    getDefaultRestAPIV4(site_uuid).get(
        routes.subscriptions(site_uuid, uuid),
        { limit: 100 },
    );

export const fetchFollowers = (uuid, site_uuid) =>
    getDefaultRestAPIV4(site_uuid).get(
        routes.subscribers(site_uuid, uuid),
        { limit: 100 },
    );

export const refreshUserTokenRequest = (site_id) => restAPIV2.register(config.api_v2_url, site_id).get(routes.refreshUserTokenRoute());
